"use client";

import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

// A CSS transition keeps the motion runtime out of every portal page's initial
// JavaScript; the panel slide is a state change, not direct manipulation.
const PANEL_CLASS =
  "absolute inset-0 flex flex-col overflow-y-auto overscroll-contain transition-[transform,opacity] duration-300 [transition-timing-function:cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none";

type PortalMorphingSidebarNavProps = {
  adminActive: boolean;
  adminPanel: ReactNode;
  portalPanel: ReactNode;
};

export function PortalMorphingSidebarNav({
  adminActive,
  adminPanel,
  portalPanel,
}: PortalMorphingSidebarNavProps) {
  return (
    <div className="relative flex min-h-0 flex-1 flex-col overflow-hidden">
      <div
        aria-hidden={adminActive}
        className={cn(
          PANEL_CLASS,
          adminActive && "pointer-events-none -translate-y-full opacity-35",
        )}
        inert={adminActive || undefined}
      >
        {portalPanel}
      </div>
      <div
        aria-hidden={!adminActive}
        className={cn(
          PANEL_CLASS,
          !adminActive && "pointer-events-none translate-y-full opacity-35",
        )}
        inert={!adminActive || undefined}
      >
        {adminPanel}
      </div>
    </div>
  );
}
